export default {
    yes: "Ναι",
    no: "Όχι",
    "0": {
        "question": "Πριν απο το γεύμα η πείνα μου:",
        "option": {
            "0": "Καθόλου",
            "1": "Ήπια",
            "2": "Μέτρια",
            "3": "Έντονη",
            "4": "Επείγουσα"
        }
    },
    "1": {
        "question": "Πόση ώρα έχει περάσει από το προηγούμενο μου γεύμα;",
        "option": {
            "0": "Λιγότερο από 1 ώρα",
            "1": "1–2 ώρες",
            "2": "3–4 ώρες",
            "3": "Πάνω από 4 ώρες"
        }
    },
    "2": {
        "question": "Έχω σωματικά σημάδια πείνας;",
        "desc": "(π.χ. γουργούρισμα στο στομάχι, ελαφριά ζάλη, έλλειψη ενέργειας, αίσθημα αδυναμίας, ατονία, κούραση, έλλειψη συγκέντρωσης)"
    },
    "3": {
        "question": "Τι συναίσθημα είχα/έχω πρίν φάω:",
        "desc": "(που μπορεί να μοιάζουν με πείνα)",
        "option": {
            "0": "\uD83D\uDE30 Άγχος / Πίεση",
            "1": "\uD83D\uDE14 Λύπη / Θλίψη",
            "2": "\uD83D\uDE12 Βαρεμάρα",
            "3": "\uD83D\uDE20 Θυμός / Ένταση",
            "4": "\uD83D\uDE29 Απογοήτευση / Ματαίωση",
            "5": "\uD83D\uDE22 Μοναξιά",
            "6": "\uD83D\uDE24 Εκνευρισμός",
            "7": "\uD83D\uDE2C Ενοχή",
            "8": "\uD83E\uDEE3 Ντροπή / Αυτοκριτική",
            "9": "\uD83D\uDE35 Σύγχυση / Υπερφόρτωση",
            "10": "\uD83E\uDD2F Ανάγκη ελέγχου",
            "11": "\uD83E\uDEE5 Απώλεια ελέγχου",

            "12": "\uD83D\uDC94 Στεναχώρια για κάποιον άλλο",
            "13": "\uD83E\uDD17 Ανάγκη για “αγκαλιά” / τρυφερότητα",
            "14": "\uD83E\uDEE4 Αίσθημα \"κενού\" ή “δεν ξέρω τι έχω”",
            "15": "\uD83D\uDE0D Ενθουσιασμός / Ευφορία (π.χ. “θέλω να το γιορτάσω”)",
            "16": "\uD83E\uDDE0 Νοσταλγία / Σύνδεση με αναμνήσεις"
        }
    },
    "4" : {
        "separator": "Αισθανόμουν μετά",
        "question": "✅ Θετικά συναισθήματα / καταστάσεις:",
        "option": {
            "0": "\uD83D\uDE0A Ικανοποίηση",
            "1": "\uD83D\uDE0C Ανακούφιση",
            "2": "\uD83C\uDF3F Ηρεμία",
            "3": "\uD83D\uDCAA Ενέργεια",
            "4": "\uD83E\uDDE0 Καθαρή σκέψη",
            "5": "❤\uFE0F Αυτοφροντίδα / σεβασμός",
            "6": "\uD83D\uDE42 Χόρτασα επαρκώς",
            "7": "\uD83D\uDC9A Νιώθω καλά με την επιλογή μου"
        }
    },
    "5": {
        "question": "❗ Μικτές ή αρνητικές καταστάσεις:",
        "option": {
            "0": "\uD83E\uDD22 Φούσκωμα",
            "1": "\uD83D\uDE1E Ενοχές / τύψεις",
            "2": "\uD83E\uDD74 Έφαγα πολύ παραπάνω",
            "3": "\uD83D\uDE24 Απογοήτευση",
            "4": "\uD83E\uDEE3 Έλλειψη ελέγχου",
            "5": "\uD83E\uDD2F Σαν να μην με “γέμισε”",
            "6": "\uD83D\uDE36 Απουσία συναισθήματος – το έκανα μηχανικά",
            "7": "\uD83E\uDDE9 Κάτι άλλο ζητούσα αλλά δεν το βρήκα"
        }
    },
    "6": {
        "question": "\uD83D\uDCCC Extra (για journaling):",
        "placeholder": "✍\uFE0F Θες να το περιγράψεις με δικά σου λόγια;"
    },
    "7": {
        "question": "Καταγραφή διάρκειας γεύματος",
        "placeholder": "⏱️ Πόση ώρα διήρκησε το γεύμα σου;"
    },

    tooltip: 'Προβολή συναισθημάτων',
    keepOpen: 'Ενεργοποίηση αυτόματης προβολής συναισθημάτων'
}